module.exports = __webpack_public_path__ + "img/usability-test-mobile.56ce3cdf.png";